module.exports = __webpack_public_path__ + "static/media/05.26129dc6.webp";